var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2868 26.7208C39.8269 26.7208 38.3285 29.3535 36.4487 29.3535C31.4508 29.3535 36 14.6665 36 14.6665C36 14.6665 19.6427 21.3332 19.6427 14.3918C19.6427 11.4062 22.6667 10.5376 22.6667 7.22634C22.6667 4.26784 20.3238 2.6665 17.5449 2.6665C14.6571 2.6665 12.0144 4.24075 12.0144 7.362C12.0144 10.809 14.657 12.3018 14.657 14.1745C14.6571 19.9764 0 16.563 0 16.563V44.3328C0 44.3328 14.8862 47.7533 14.8862 41.9443C14.8862 40.0715 11.5529 38.602 11.5529 35.155C11.5529 32.0337 13.9904 30.4595 16.851 30.4595C19.6571 30.4595 22 32.0608 22 35.0193C22 38.3305 18.976 39.1991 18.976 42.1847C18.976 47.2516 29.7822 44.3288 34.0785 44.3288C34.0785 44.3288 31.1848 34.3204 36.2308 34.3204C39.2276 34.3204 40.0993 37.3331 43.4231 37.3331C46.3927 37.3332 48 34.999 48 32.2034C48 29.3535 46.4198 26.7208 43.2868 26.7208Z",
    fill: "#3B82F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavy);
export default __webpack_public_path__ + "static/media/Navy.b8a4800eb025d3240e902413d75db7dc.svg";
export { ForwardRef as ReactComponent };